import { useLingui } from '@lingui/react/macro'
import Link from 'next/link'

export const Cocoon = () => {
	const { t } = useLingui()

	return (
		<ul className='flex flex-col'>
			<li className='mb-1 font-bold'>{t`Les Cocoons`}</li>

			<li>
				<Link
					href='/salle-de-reunion/paris'
					target='_blank'
					className='text-sm hover:text-primary'
				>
					{t`Salle de réunion à Paris`}
				</Link>
			</li>

			<li>
				<Link
					href='/bureau-a-l-heure/paris'
					target='_blank'
					className='text-sm hover:text-primary'
				>
					{t`Bureau à l'heure dans Paris`}
				</Link>
			</li>

			<li>
				<Link
					href='/salle-de-reunion/lyon'
					target='_blank'
					className='text-sm hover:text-primary'
				>
					{t`Salle de réunion à Lyon`}
				</Link>
			</li>

			<li>
				<Link
					href='/bureau-a-l-heure/lyon'
					target='_blank'
					className='text-sm hover:text-primary'
				>
					{t`Bureau à l'heure dans Lyon`}
				</Link>
			</li>
		</ul>
	)
}
